import React, { useState } from 'react';
import { Button, DatePicker, Divider, Drawer, Form, Input, Row, Select, Space } from 'antd';
import { fetchData } from '../../service/dataServices';
import { Option } from 'antd/es/mentions';
import { useTranslation } from 'react-i18next'; // Added
import { getLocalizedTitle, getLocalizedName } from '../../utils/localization';

const { RangePicker } = DatePicker;

const FilterDrawer = ({ drawerVisible, setDrawerVisible, setFilters, filters }) => {
  const { t } = useTranslation(); // Added
  const [form] = Form.useForm();
  const [dropdowns, setDropdowns] = useState();
  const [addressData, setAddressData] = useState([]);
  const [selectedHall, setSelectedHall] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);

  fetchData('/api/dropdowns', setDropdowns);
  fetchData('/api/addresses', setAddressData);

  const onFinish = (values) => {
    setFilters(prevState => ({
      ...prevState,
      ...values,
      page: 0,
      startDate: values.date && values.date[0] ? values.date[0].format("YYYY-MM-DD") : undefined,
      endDate: values.date && values.date[1] ? values.date[1].format("YYYY-MM-DD") : undefined,
      date: undefined,
    }));
  }

  const getDropdownOptions = (type) => {
    if (dropdowns) {
      return dropdowns[type];
    }
    return [];
  };

  const getSelectFormItem = (type, label, multiple = false) => {
    return (
      <Form.Item label={t(`objects.${type}`)} name={type}>
        <Select placeholder={`${t('objects.select')} ${t(`objects.${type}`) || type}`} mode={multiple ? 'tags' : false} allowClear>
          {
            getDropdownOptions(type)?.map(option => (
              <Option value={option.id} key={option.id}>{getLocalizedTitle(option)}</Option>
            ))
          }
        </Select>
      </Form.Item>
    );
  };

  const getDropdownFormItem = (type, label) => {
    return getSelectFormItem(type, label);
  };

  const getInputFormItem = (name, label, required = false) => (
    <Form.Item
      label={t(`objects.${name}`)}
      name={name}
      rules={required ? [{ required: true, message: `${t(`objects.${name}`)} ${t('objects.isRequired')}` }] : []}
    >
      <Input placeholder={t(`objects.${name}`)} allowClear />
    </Form.Item>
  );

  const getDatePickerFormItem = (name, label) => (
    <Form.Item
      label={t(`objects.${name}`)}
      name={name}
    >
      <RangePicker />
    </Form.Item>
  )

  const onClear = () => {
    form.resetFields();
    setFilters({
      page: 0,
      size: 10,
    });
  }

  return (
    (<Drawer
      title={t('objects.filters')}
      placement="right"
      size="large"
      onClose={() => setDrawerVisible(false)}
      open={drawerVisible}
      destroyOnHidden
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={filters}
      >
        {getInputFormItem("inventoryNumber", "Inventory Number")}
        {getInputFormItem("objectName", "Object Name")}
        {getInputFormItem("objectTitle", "Object Title")}
        {getDropdownFormItem('classification', 'Classification')}
        {getDropdownFormItem('category', 'Category')}
        {getInputFormItem("country", "Country")}
        {getInputFormItem("description", "Description")}
        {getInputFormItem("showcaseNumber", "Showcase Number")}
        {getDropdownFormItem('location', 'Location')}
        {getInputFormItem('century', 'Century')}
        {getDatePickerFormItem('date', 'Date')}

        <Divider />
        <Form.Item label={t('objects.hall')} name="hallId">
          <Select
            showSearch
            filterOption
            optionFilterProp="children"
            placeholder={`${t('common.select')} ${t('objects.hall')}`}
            allowClear
            onChange={(value) => {
              if (value) {
                const hall = addressData.find(h => h.id === value);
                setSelectedHall(hall || null);
              } else {
                setSelectedHall(null);
              }
              setSelectedZone(null);
              form.setFieldsValue({ zoneId: undefined, displayStationId: undefined });
            }}
          >
            {addressData.map(hall => (
              <Option value={hall.id} key={hall.id}>{getLocalizedName(hall)}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label={t('objects.zone')} name="zoneId">
          <Select
            showSearch
            filterOption
            optionFilterProp="children"
            placeholder={`${t('common.select')} ${t('objects.zone')}`}
            allowClear
            disabled={!selectedHall}
            onChange={(value) => {
              if (value && selectedHall) {
                const zone = selectedHall.children?.find(z => z.id === value);
                setSelectedZone(zone || null);
              } else {
                setSelectedZone(null);
              }
              form.setFieldsValue({ displayStationId: undefined });
            }}
          >
            {selectedHall?.children?.map(zone => (
              <Option value={zone.id} key={zone.id}>{getLocalizedName(zone)}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label={t('objects.displayStation')} name="displayStationId">
          <Select
            showSearch
            filterOption
            optionFilterProp="children"
            placeholder={`${t('common.select')} ${t('objects.displayStation')}`}
            allowClear
            disabled={!selectedZone}
          >
            {selectedZone?.children?.map(station => (
              <Option value={station.id} key={station.id}>{getLocalizedName(station)}</Option>
            ))}
          </Select>
        </Form.Item>

        <Divider />
        <Row justify="center">
          <Space align="center">
            <Button type="primary" htmlType="submit">
              {t('objects.search')}
            </Button>
            <Button onClick={onClear}>
              {t('objects.clear')}
            </Button>
          </Space>
        </Row>
      </Form>
    </Drawer>)
  );
};

export default FilterDrawer;